import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      d="M18.68 6.368l.082.073 9.81 10.06a.8.8 0 01.072 1.032l-.076.09-7.883 7.94a.8.8 0 01-1.046.079l-.09-.078-9.331-9.399-5.65 5.693a.8.8 0 01-1.042.081l-.09-.077a.8.8 0 01-.08-1.041l.076-.09 14.19-14.295a.8.8 0 011.059-.068zm.345 10.788l-2.78 2.809 3.871 3.899 2.799-2.819-3.89-3.889zm4.004-4.048l-2.879 2.911 3.892 3.891 2.836-2.856-3.849-3.946zm-8.919-.865l-2.765 2.786 3.773 3.801 2.775-2.805-3.783-3.782zm4.074-4.103l-2.946 2.968 3.78 3.78 2.894-2.925-3.728-3.823z"
    />
  </svg>
);

const IconOffside = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconOffside;
